exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".material-icons {\n  font-size: 50px;\n  display: block; }\n\n.term-icon {\n  display: block; }\n\nmat-grid-tile {\n  background-color: #000;\n  color: #fff;\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Quentin/projets/kontractor/src/app/components/doc-choice/doc-choice.component.scss
// module id = ../../../../../src/app/components/doc-choice/doc-choice.component.scss
// module chunks = main